import React, { useEffect } from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { TextBox } from 'components/form/TextBox/TextBox';
import Label from 'components/form/Label/Label';
import { validateFirstName, validateLastName } from 'helpers/signup.helpers';

const NameFormOneClickApplication = props => {
  const { nameState, setNameState } = props;
  useEffect(() => {
    const firstNameError = validateFirstName(nameState?.firstName);
    setNameState({
      firstNameError: firstNameError,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameState?.firstName]);

  useEffect(() => {
    const lastNameError = validateLastName(nameState?.lastName);
    setNameState({
      lastNameError: lastNameError,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameState?.lastName]);
  return (
    <FlexContainer className="flex-column gap-8">
      <Label typeHeader={'h4'} className="H4  text-16">
        Name
      </Label>
      <FlexContainer className="m-flex-column justify-between gap-16">
        <FlexContainer className={'flex-column textBoxw260'}>
          <TextBox
            id="firstName"
            name="firstName"
            datatestid="firstName"
            placeholder="First Name"
            type="text"
            value={nameState?.firstName}
            error={nameState?.firstNameError}
            fullWidth={true}
            onChange={e => setNameState({ firstName: e.target.value })}
          />
        </FlexContainer>
        <FlexContainer className={'flex-column textBoxw165'}>
          <TextBox
            id="MiddleInitial"
            name="MiddleInitial"
            datatestid="MiddleInitial"
            placeholder="MI (optional)"
            value={nameState?.middleInitial}
            error={nameState?.middleInitialError}
            fullWidth={true}
            onChange={e => setNameState({ middleInitial: e.target.value })}
          />
        </FlexContainer>
        <FlexContainer className={'flex-column textBoxw260'}>
          <TextBox
            id="lastName"
            name="lastName"
            datatestid="lastName"
            placeholder="Last Name"
            value={nameState?.lastName}
            error={nameState?.lastNameError}
            fullWidth={true}
            onChange={e => setNameState({ lastName: e.target.value })}
          />
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default NameFormOneClickApplication;
